const stats = [
  { label: '覆盖专区', value: '12+' },
  { label: '已归档精选帖', value: '3600+' },
  { label: '补录进度', value: '2026.09' },
  { label: '整理节奏', value: '每日更新' },
];

const chips = ['绯闻瓜', '直播瓜', '综艺瓜', '商业瓜', '塌房复盘', '老帖索引'];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-16 md:pt-[72px]">
      {/* warm tinted backdrop */}
      <div className="dot-texture absolute inset-0 bg-gradient-to-b from-amber-50/70 via-[#f8f4ec] to-[#f8f4ec]" aria-hidden="true" />
      <div className="pointer-events-none absolute -right-16 top-10 h-72 w-72 rounded-full bg-gradient-to-tr from-red-400/20 to-orange-300/20 blur-3xl" aria-hidden="true" />
      <div className="pointer-events-none absolute -left-20 bottom-4 h-64 w-64 rounded-full bg-gradient-to-tr from-amber-300/20 to-yellow-200/20 blur-3xl" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-14 md:px-6 md:pb-20 md:pt-20">
        <div className="grid items-center gap-12 lg:grid-cols-[1.15fr_0.85fr]">
          {/* text-first column */}
          <div className="animate-fade-up">
            <div className="inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-3 py-1 text-xs font-bold text-red-600">
              <i className="ri-flashlight-fill" />
              53吃瓜 · 整理向补漏站
            </div>

            <h1 className="font-serif-sc mt-6 text-4xl font-black leading-[1.2] tracking-tight text-stone-900 md:text-[52px] md:leading-[1.18]">
              把错过的瓜，
              <br />
              一条条<span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">补回来</span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-600 md:text-lg">
              53吃瓜 汇总<b className="text-stone-800">往期精选</b>、<b className="text-stone-800">合集存档</b>与
              <b className="text-stone-800">目录老帖</b>，按时间线一条条复盘。想看之前的瓜料、补漏错过的帖子，不用自己翻楼——分区分类，边刷边补。
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#featured"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-red-500 to-orange-400 px-7 py-3.5 text-base font-bold text-white transition-transform hover:-translate-y-0.5"
              >
                浏览往期精选
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-stone-300 bg-white px-7 py-3.5 text-base font-bold text-stone-800 transition-colors hover:border-stone-900 hover:bg-stone-900 hover:text-white"
              >
                <i className="ri-fire-line text-red-500" />
                先看今日热榜
              </a>
            </div>

            {/* quick chips */}
            <div className="mt-8 flex flex-wrap items-center gap-2">
              <span className="text-xs font-medium text-stone-400">常逛专区</span>
              {chips.map((c) => (
                <a
                  key={c}
                  href="#zones"
                  className="rounded-full bg-white/80 px-3 py-1.5 text-xs font-medium text-stone-600 ring-1 ring-stone-200 transition-colors hover:text-red-600 hover:ring-red-300"
                >
                  {c}
                </a>
              ))}
            </div>
          </div>

          {/* visual as backdrop — stat card + mini index panel */}
          <div className="relative hidden lg:block">
            <div className="animate-float relative rounded-3xl border border-stone-200/70 bg-white/80 p-6 shadow-[0_20px_50px_-30px_rgba(180,83,9,0.35)] backdrop-blur">
              <div className="flex items-center justify-between">
                <span className="text-sm font-bold text-stone-800">53吃瓜 · 补漏面板</span>
                <span className="flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[11px] font-bold text-emerald-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                  补录中
                </span>
              </div>

              <div className="mt-5 grid grid-cols-2 gap-3">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-2xl bg-amber-50/70 p-3">
                    <div className="font-serif-sc text-2xl font-black text-stone-900">{s.value}</div>
                    <div className="mt-1 text-[11px] font-medium text-stone-500">{s.label}</div>
                  </div>
                ))}
              </div>

              <div className="mt-5 space-y-2.5">
                {[
                  { k: '09-02', t: '顶流恋爱瓜线索并入时间线', tag: '绯闻' },
                  { k: '09-01', t: '主播翻车全程复盘已归档', tag: '直播' },
                  { k: '08-30', t: '新开合集：上半年综艺争议', tag: '合集' },
                ].map((r) => (
                  <div key={r.t} className="flex items-center gap-3 rounded-xl border border-stone-100 bg-white p-2.5">
                    <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-50 text-[11px] font-bold text-red-600">
                      {r.k}
                    </span>
                    <span className="flex-1 truncate text-sm text-stone-700">{r.t}</span>
                    <span className="whitespace-nowrap rounded-full bg-stone-100 px-2 py-0.5 text-[11px] font-medium text-stone-500">
                      {r.tag}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* floating index badge */}
            <div className="animate-float absolute -bottom-5 -left-6 flex items-center gap-3 rounded-2xl border border-stone-200 bg-white px-4 py-3 shadow-[0_14px_30px_-24px_rgba(0,0,0,0.4)] [animation-delay:1.5s]">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 text-white">
                <i className="ri-archive-line text-lg" />
              </span>
              <div>
                <div className="font-serif-sc text-lg font-black leading-none text-stone-900">860+</div>
                <div className="mt-1 text-[11px] text-stone-500">老帖目录已入库</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}